import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function BackToAdmin(){
    return <Link to="/allpages" className="flex justify-center items-center bg-slate-200 py-1  px-4 rounded-lg gap-2" >
    <FaArrowLeft className="pt-0.5"/>
    <button>Back</button> 
     </Link> 
}